module.exports = __webpack_public_path__ + "img/nodata.275a319c.png";